"use client";

import NextLink from "next/link";
import { useLoadingState } from "@/hooks/useLoadingState";
import type { LinkProps as NextLinkProps } from "next/link";

interface ClientLinkProps extends NextLinkProps {
  children: React.ReactNode;
  className?: string;
  target?: string;
  onClick?: (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => void;
  prefetch?: boolean;
}

export default function Link({
  children,
  onClick,
  target,
  prefetch,
  className,
  ...props
}: ClientLinkProps) {
  const { setIsLoading } = useLoadingState();

  const handleClick = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
    setIsLoading(true);
    if (onClick) onClick(e);
  };

  return (
    <NextLink
      {...props}
      onClick={handleClick}
      prefetch={prefetch}
      target={target}
      className={className}
    >
      {children}
    </NextLink>
  );
}
